module.exports = __webpack_public_path__ + "img/gc_country_flag_pl.148d5113.svg";